// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function BabyIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M11.5 17.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm9-3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm-1.534 5.654a5.625 5.625 0 0 1-5.932 0 1.001 1.001 0 0 0-1.068 1.692 7.625 7.625 0 0 0 8.068 0 1 1 0 0 0-1.068-1.692ZM29 16A13 13 0 1 1 16 3a13.014 13.014 0 0 1 13 13Zm-2 0A11.014 11.014 0 0 0 16.489 5.011C15.04 7.048 15 8.985 15 9a1 1 0 0 0 2 0 1 1 0 0 1 2 0 3 3 0 0 1-6 0c0-.091.016-1.787 1.057-3.829A11 11 0 1 0 27 16Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
